import { Box, Typography } from '@mui/material';
import { colors } from '@src/styles';
import { fmtDuration, monoFontFamily } from '../utils/format';

export function LatencyBars({ p50, p95, p99, max }: { p50: number; p95: number; p99: number; max: number }) {
  const rows: [string, number, string][] = [
    ['p50', p50, colors.status.concluded],
    ['p95', p95, colors.status.pending],
    ['p99', p99, colors.primary.yellow],
    ['máx', max, colors.status.rejected],
  ];
  const scale = Math.max(max, 1);
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, py: 1 }}>
      {rows.map(([label, val, color]) => (
        <Box key={label} sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Typography
            sx={{
              width: 34,
              fontFamily: monoFontFamily,
              fontSize: '11px',
              letterSpacing: '0.08em',
              textTransform: 'uppercase',
              color: colors.brand.textMuted,
            }}
          >
            {label}
          </Typography>
          <Box
            sx={{
              flex: 1,
              height: 22,
              borderRadius: '6px',
              backgroundColor: 'rgba(255, 255, 255, 0.04)',
              overflow: 'hidden',
            }}
          >
            <Box
              sx={{
                height: '100%',
                width: `${Math.max((val / scale) * 100, 2)}%`,
                background: `linear-gradient(90deg, ${color}66, ${color})`,
                borderRadius: '6px',
              }}
            />
          </Box>
          <Typography
            sx={{
              width: 56,
              fontFamily: monoFontFamily,
              fontSize: '12px',
              fontWeight: 500,
              color: colors.brand.textStrong,
              textAlign: 'right',
              fontVariantNumeric: 'tabular-nums',
            }}
          >
            {fmtDuration(val)}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
